import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {ObservableBackendService} from "./observableBackend.service";
import {SendActPayReceiptForm} from "../domain/sendActPayReceiptForm";
import {ContactInfo} from "../domain/contactInfo";
import {Infraction} from "../domain/infraction";
import {Procedure} from "../domain/procedure";
import {SendRequestProcedureForm} from "../domain/sendRequestProcedureForm";
import {Vehicle} from "../domain/vehicle";

@Injectable()
export class ClientService {

    constructor(private backendService: ObservableBackendService) {
    }

    public sendRequestProcedure(form: SendRequestProcedureForm): Observable<boolean> {
        return this.backendService.post("client/sendRequestProcedure", form, null);
    }

    public deleteTempRequestProcedure(procedureId: string, documentType: string): Observable<boolean> {
        return this.backendService.delete("client/" + procedureId + "/documentTemp/" + documentType, null, null);
    }

    public deleteTempActPayReceipt(): Observable<boolean> {
        return this.backendService.delete('client/actPayReceipt', null, null);
    }

    public sendActPayReceipt(form: SendActPayReceiptForm): Observable<boolean> {
        return this.backendService.post("client/sendActPayReceipt", form, null);
    }

    public sendContactInfo(form: ContactInfo): Observable<boolean> {
        return this.backendService.post("sendContactInfo", form, null);
    }

    public getInfractionActNumbers(): Observable<Infraction> {
        return this.backendService.post("infraction/getInfractionActNumbers", null, null);
    }

    public getVehiclesByCUIT(cuitNumber:string){
        return this.backendService.post("vehicle/getVehiclesByCUIT", cuitNumber, null);
    }

    public isPayReceiptActive(): Observable<boolean> {
        return this.backendService.get("isPayReceiptActive", null);
    }


}


/** WEBPACK FOOTER **
 ** ./src/app/service/client.service.ts
 **/